export enum ArchiveCatalogNameDynamicType {
  NONE = 'NONE',
  SECTION_CODE = 'SECTION_CODE',
  MATERIAL_TYPE_NAME = 'MATERIAL_TYPE_NAME',
  WBS_DW_TYPE_NAME = 'WBS_DW_TYPE_NAME',
  WBS_NAME = 'WBS_NAME',
  WBS_CODE_NAME = 'WBS_CODE_NAME',
}

export const ArchiveCatalogNameDynamicTypeMap = {
  [ArchiveCatalogNameDynamicType.NONE]: '无',
  [ArchiveCatalogNameDynamicType.SECTION_CODE]: '合同号',
  [ArchiveCatalogNameDynamicType.MATERIAL_TYPE_NAME]: '材料类型',
  [ArchiveCatalogNameDynamicType.WBS_DW_TYPE_NAME]: 'WBS单位工程类型',
  [ArchiveCatalogNameDynamicType.WBS_NAME]: 'WBS单位工程(仅名称)',
  [ArchiveCatalogNameDynamicType.WBS_CODE_NAME]: 'WBS单位工程(编号+名称)',
};

export const ArchiveCatalogNameDynamicTypeList = [
  {
    label: ArchiveCatalogNameDynamicTypeMap[ArchiveCatalogNameDynamicType.NONE],
    value: ArchiveCatalogNameDynamicType.NONE,
  },
  {
    label:
      ArchiveCatalogNameDynamicTypeMap[
        ArchiveCatalogNameDynamicType.SECTION_CODE
      ],
    value: ArchiveCatalogNameDynamicType.SECTION_CODE,
  },
  {
    label:
      ArchiveCatalogNameDynamicTypeMap[
        ArchiveCatalogNameDynamicType.MATERIAL_TYPE_NAME
      ],
    value: ArchiveCatalogNameDynamicType.MATERIAL_TYPE_NAME,
  },
  {
    label:
      ArchiveCatalogNameDynamicTypeMap[
        ArchiveCatalogNameDynamicType.WBS_DW_TYPE_NAME
      ],
    value: ArchiveCatalogNameDynamicType.WBS_DW_TYPE_NAME,
  },
  {
    label:
      ArchiveCatalogNameDynamicTypeMap[ArchiveCatalogNameDynamicType.WBS_NAME],
    value: ArchiveCatalogNameDynamicType.WBS_NAME,
  },
  {
    label:
      ArchiveCatalogNameDynamicTypeMap[
        ArchiveCatalogNameDynamicType.WBS_CODE_NAME
      ],
    value: ArchiveCatalogNameDynamicType.WBS_CODE_NAME,
  },
];

export const ArchiveCatalogNameDynamicSmallTypeList = [
  {
    label: '(仅名称)',
    value: ArchiveCatalogNameDynamicType.WBS_NAME,
  },
  {
    label: '(编号+名称)',
    value: ArchiveCatalogNameDynamicType.WBS_CODE_NAME,
  },
];
